import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { fade, lighten, makeStyles } from '@material-ui/core/styles';
import { Table, InputBase, Button, CircularProgress, Box, Tooltip, IconButton } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import SearchIcon from "@material-ui/icons/Search";
import SingleParentData from './SingleParentData';
import PaymentParentData from './PaymentParentData';
import { GlobalContext } from "../../context/GlobalState";
import AddParent from './AddParent';
import { Edit, VisibilitySharp } from '@material-ui/icons';
import UpdateParent from './Updateparent';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ParentPersonalDetails from './ParentPersonalDetails';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'name', disablePadding: true, label: 'Parent' },
  { id: 'infoStudentName', label: 'Student' },
  { id: 'infoStudentProgram', label: 'Enrolled For' },
  { id: 'email', label: 'Email' },
  { id: 'centerCode', label: 'Center Code' },
  { id: 'mobileNo', numeric: false, disablePadding: true, label: 'Contact' },
  { id: 'currentPoints', numeric: false, disablePadding: true, label: 'Points' },
  { id: "action", label: "Action" }
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">

        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'center' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto"
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit",
    border: '1px solid #dddd',
    margin: '6px 6px 0px 6px',
    borderRadius: '6px'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch"
      }
    }
  },
  tbrow: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#faebd761",
    },
    "&:hover": {
      boxShadow: "0px 2px 5px lightsteelblue",
    },
  }
  // spin: {
  //   display: 'flex',

  // }
}));

export default function AllParents() {
  const classes = useStyles();
  //const [rows, setData] = useState([]);
  const [data, setData] = useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [onpayment, setPayment] = React.useState(false)
  const [spinner, setSpinner] = React.useState(true);
  // const [newdata, setNewdata] = React.useState({})
  const [newdata1, setNewdata1] = React.useState({})
  const [addParent, setAddParent] = React.useState(false);
  const [editingStudent, setEditingStudent] = React.useState(false);
  const [updatingPayment, setUpdatingPayment] = React.useState(false);
  const { allparents, getParentDetails, encodeDecodeString } = React.useContext(GlobalContext);
  const isAdmin = encodeDecodeString(window.localStorage.getItem("user"),'decode');
  React.useEffect(() => {
    setData(allparents);
    setTimeout(() => setSpinner(false), 3000)
    // console.log(allparents)
  }, [allparents]);

  React.useEffect(() => {

    let searched = allparents.filter(
      row =>
        row.mobileNo.includes(searchTerm) ||
        row.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        row.email.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        row.centerCode.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        row.student.some(std =>
          std.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
          std.program.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
        )
    );

    if (searchTerm === "") {
      getParentDetails();
      setData(searched);
    } else {
      setData(searched);
    }
  }, [searchTerm]);

  const handleSearch = event => {
    setSearchTerm(event.target.value);
  };


  const showPayments = (e, id) => {
    setPayment(true)
    //setDetails(false)
    var data1 = allparents.filter(item => item._id === id)
    setNewdata1(data1[0])
    //getSingleFacultyClassDetails(id)
  };

  const updatePayments = (e, id) => {
    var data1 = allparents.filter(item => item._id === id)
    setNewdata1({ ...data1[0], fromListing: true })
    setUpdatingPayment(true)
  }

  const editStudent = (e, id) => {
    var data1 = allparents.filter(item => item._id === id)
    setNewdata1({ ...data1[0], fromListing: true })
    setEditingStudent(true)
  };


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = allparents.map((n) => n.user.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const goToAddParent = () => {
    setAddParent(true);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, allparents.length - page * rowsPerPage);

  if (onpayment) { return <SingleParentData showPayments={newdata1} /> }
  if (addParent) { return <AddParent /> }
  if (editingStudent) {
    return <UpdateParent showData={newdata1} />
  }
  if (updatingPayment) {
    return <PaymentParentData showData={newdata1} />
  }
  return (
    <div className={classes.root}>
      {isAdmin !== "operations" && isAdmin !== "coo" && isAdmin !== "academics" ?
      <Box display="flex" pb={2}>
        <Box flexGrow={1}>
          <Button
            onClick={goToAddParent}
            type="submit"
            size="large"
            pt={2}
            variant="contained"
            color="primary"
          >
            Add New Parent
          </Button>
        </Box>
      </Box> : "" }
      <Paper className={classes.paper}>
        <div className={classes.search} style={{ display: "inline-block" }}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "search" }}
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={allparents.length}
            />

            {spinner ? (
              <TableBody style={{ position: "relative" }}>
                <TableRow>
                  <TableCell>
                    <CircularProgress
                      style={{ padding: "5px", position: "absolute", left: "50%" }}
                      color="primary"
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
                <TableBody>
                  {stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const filteredStudent = row?.student?.filter(e => e?.approval_status?.status !== "Opted Out");
                      let num = "";
                      let programNum = "";
                      if (filteredStudent?.length > 1) {
                        num = ` +${filteredStudent?.length - 1}`
                        let programs = new Set(filteredStudent.map(item => item.program))
                        programs = [...programs]
                        if (programs.length > 1) {
                          programNum = ` +${programs?.length - 1}`
                        }
                      }
                      return (
                        <TableRow
                          className={classes.tbrow}
                          key={row._id}
                          style={{ cursor: "pointer" }}
                          hover>
                          <TableCell padding="checkbox"></TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            {row.name.toLowerCase().replace(/\b./g, function (a) {
                              return a.toUpperCase();
                            })}
                          </TableCell>
                          <TableCell>
                            {row?.infoStudentName ? row?.infoStudentName.toLowerCase()
                              .replace(/\b./g, function (a) {
                                return a.toUpperCase();
                              }) + num : "NA"}
                          </TableCell>
                          <TableCell>
                            {row?.infoStudentProgram ? row?.infoStudentProgram.toLowerCase()
                                .replace(/\b./g, function (a) {
                                  return a.toUpperCase();
                                }) + programNum : "NA"}
                          </TableCell>
                          <TableCell>{row.email.toLowerCase()}</TableCell>
                          <TableCell>{row?.centerCode? row?.centerCode : "N/A"}</TableCell>
                          <TableCell component="th" scope="row" padding="none">{row.mobileNo}</TableCell>
                          <TableCell>{row.currentPoints}</TableCell>
                          <TableCell align="center">
                          {isAdmin !== "operations" && isAdmin !== "coo" && isAdmin !== "academics" && isAdmin !== "marketing" &&
                            <Tooltip title="Edit" arrow>
                              <IconButton className="bg5" className="bg5" onClick={e => editStudent(e.currentTarget.value, row._id)}>
                                <Edit />
                              </IconButton>
                            </Tooltip> }
                            <Tooltip title="View" arrow>
                              <IconButton className="bg5" onClick={e => showPayments(e.currentTarget.value, row._id)}>
                                <VisibilitySharp />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Add Payment" arrow>
                              <IconButton disabled={isAdmin === 'marketing' || isAdmin === 'coo' || isAdmin === 'academics'} className="bg5" onClick={e => updatePayments(e.currentTarget.value, row._id)}>
                                <AttachMoneyIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              )}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 75, 100, 500]}
          component="div"
          count={allparents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
